import React from 'react';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';

import DuetModal2, { DuetIconContainer, DuetLeftRightButtons } from '../../../components/Modals/modal2';

import styles from './styles.module.scss';
import modalStyles from '../../../components/Modals/modal2.module.scss';

const NotAllowedToRemove = ({ show, close }) => {
  return (
    <>
      <DuetModal2 show={show}>
        <DuetIconContainer>
          <img
            style={{ width: '57px', height: '57px' }}
            src={`${process.env.PUBLIC_URL}/resources/images/info-circle-blue.svg`}
            alt=""
          />
        </DuetIconContainer>
        <div className={`${styles['modal-subtitle']} m-t-30 m-b-20`}>
          The selected booking can&apos;t be removed because its passenger is either onboard or dropped off.
        </div>
        <div className="m-t-40">
          <DuetLeftRightButtons>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Button
                variant="primary"
                type="button"
                className={classNames(modalStyles.button, 'w-80', 'm-l-12')}
                disabled={false}
                onClick={close}
              >
                Ok
              </Button>
            </div>
          </DuetLeftRightButtons>
        </div>
      </DuetModal2>
    </>
  );
};

export default NotAllowedToRemove;
